import React from "react";
import { connect } from "react-redux";
import { Menu, Layout, Avatar } from "antd";
import { Link, withRouter } from "react-router-dom";
import { reduce } from "lodash";
import { setLayoutState } from "ducks/app";
import { Scrollbars } from "react-custom-scrollbars";
import { default as menuData } from "./menuData";
import "./style.scss";

import { loadActiveAccountRequest } from "ducks/data";

import { bindActionCreators } from "redux";
import { makeGetAccount } from "selectors/data";
import Permissions from "../../Permissions";

const _ = require("lodash");
const { Sider } = Layout;
const SubMenu = Menu.SubMenu;
const Divider = Menu.Divider;

const makeMapStateToProps = () => {
  const getAccount = makeGetAccount();

  const mapStateToProps = (state, props) => {
    const { app, routing } = state;
    const { layoutState } = app;
    return {
      pathname: routing.location.pathname,
      collapsed: layoutState.menuCollapsed,
      theme: layoutState.themeLight ? "light" : "dark",
      settingsOpened: layoutState.settingsOpened,
      account: getAccount(state, props),
      user: app.userState
    };
  };

  return mapStateToProps;
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadActiveAccountRequest
    },
    dispatch
  );

@connect(
  makeMapStateToProps,
  mapDispatchToProps
)
@withRouter
class MenuLeft extends React.Component {
  state = {
    pathname: this.props.pathname,
    collapsed: this.props.collapsed,
    theme: this.props.theme,
    selectedKeys: "",
    openKeys: [""],
    settingsOpened: this.props.settingsOpened,
    account: this.props.account
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.props.user &&
      (!prevProps.user || prevProps.user.id !== this.props.user.id)
    ) {
      this.props.loadActiveAccountRequest();
    }
  };

  handleClick = e => {
    const { dispatch, isMobile } = this.props;
    if (isMobile) {
      // collapse menu on isMobile state
      dispatch(setLayoutState({ menuMobileOpened: false }));
    }
    if (e.key === "settings") {
      // prevent click and toggle settings block on theme settings link
      dispatch(setLayoutState({ settingsOpened: !this.state.settingsOpened }));
      return;
    }
    // set current selected keys
    this.setState({
      selectedKeys: e.key
    });
  };

  onOpenChange = openKeys => {
    this.setState({
      openKeys: openKeys
    });
  };

  getPath(data, id, parents = []) {
    const { selectedKeys } = this.state;
    let items = reduce(
      data,
      (result, entry) => {
        if (result.length) {
          return result;
        } else if (entry.url === id && selectedKeys === "") {
          return [entry].concat(parents);
        } else if (entry.key === id && selectedKeys !== "") {
          return [entry].concat(parents);
        } else if (entry.children) {
          let nested = this.getPath(
            entry.children,
            id,
            [entry].concat(parents)
          );
          return nested ? nested : result;
        }
        return result;
      },
      []
    );
    return items.length > 0 ? items : false;
  }

  getActiveMenuItem = (props, items) => {
    const { selectedKeys, pathname } = this.state;
    let { collapsed } = props;
    let [activeMenuItem, ...path] = this.getPath(
      items,
      !selectedKeys ? pathname : selectedKeys
    );

    if (collapsed) {
      path = [""];
    }

    this.setState({
      selectedKeys: activeMenuItem ? activeMenuItem.key : "",
      openKeys: activeMenuItem ? path.map(entry => entry.key) : [],
      collapsed
    });
  };

  generateMenuPartitions(items) {
    return items.map(menuItem => {
      let hasAccess =
        _.intersection(this.props.user.roles, menuItem.roles).length > 0;
      if (hasAccess && menuItem.children) {
        let subMenuTitle = (
          <span className="menuLeft__title-wrap" key={menuItem.key}>
            <span className="menuLeft__item-title">{menuItem.title}</span>
            {menuItem.icon && (
              <span className={menuItem.icon + " menuLeft__icon"} />
            )}
          </span>
        );
        return hasAccess ? (
          <SubMenu title={subMenuTitle} key={menuItem.key}>
            {this.generateMenuPartitions(menuItem.children)}
          </SubMenu>
        ) : null;
      }
      return hasAccess ? this.generateMenuItem(menuItem) : null;
    });
  }

  generateMenuItem(item) {
    const { key, title, url, icon, disabled } = item;
    const { dispatch } = this.props;
    return item.divider ? (
      <Divider key={Math.random()} />
    ) : item.url ? (
      <Menu.Item key={key} disabled={disabled}>
        <Link
          to={url}
          onClick={
            this.props.isMobile
              ? () => {
                  dispatch(setLayoutState({ menuCollapsed: false }));
                }
              : undefined
          }
        >
          {icon && <span className={icon + " menuLeft__icon"} />}
          <span className="menuLeft__item-title">{title}</span>
        </Link>
      </Menu.Item>
    ) : (
      <Menu.Item key={key} disabled={disabled}>
        {icon && <span className={icon + " menuLeft__icon"} />}
        <span className="menuLeft__item-title">{title}</span>
      </Menu.Item>
    );
  }

  onCollapse = (value, type) => {
    const { dispatch } = this.props;
    const { collapsed } = this.state;
    if (type === "responsive" && collapsed) {
      return;
    }
    dispatch(setLayoutState({ menuCollapsed: !collapsed }));
  };

  componentDidMount() {
    this.getActiveMenuItem(this.props, menuData);
  }

  componentWillReceiveProps(newProps) {
    this.setState(
      {
        selectedKeys: "",
        pathname: newProps.pathname,
        theme: newProps.theme,
        settingsOpened: newProps.settingsOpened
      },
      () => {
        if (!newProps.isMobile) {
          this.getActiveMenuItem(newProps, menuData);
        }
      }
    );
  }

  render() {
    const { collapsed, selectedKeys, openKeys, theme } = this.state;
    const { isMobile } = this.props;
    const menuItems = this.generateMenuPartitions(menuData);
    const paramsMobile = {
      width: 256,
      collapsible: false,
      collapsed: false,
      onCollapse: this.onCollapse
    };
    const paramsDesktop = {
      width: 256,
      collapsible: true,
      collapsed: collapsed,
      onCollapse: this.onCollapse,
      breakpoint: "lg"
    };
    const params = isMobile ? paramsMobile : paramsDesktop;

    let companyName =
      this.props.account &&
      this.props.account.attributes &&
      this.props.account.attributes.name;

    return (
      <Sider {...params} className="menuLeft">
        <div className="menuLeft__logo">
          {params.collapsed ? (
            <div className="menuLeft__logoContainer menuLeft__logoContainer--collapsed">
              <Avatar size={50}>
                {companyName
                  ? companyName
                      .split(" ")
                      .map(
                        (n, i, a) =>
                          i === 0 || i + 1 === a.length ? n[0] : null
                      )
                      .join("")
                  : undefined}
              </Avatar>
            </div>
          ) : (
            <div className="menuLeft__logoContainer">
              {this.props.account &&
              this.props.account.attributes &&
              this.props.account.attributes.fileUrl ? (
                <img
                  src={this.props.account.attributes.fileUrl}
                  alt="Company Logo"
                />
              ) : (
                <div className="logo-loader" />
              )}
            </div>
          )}
        </div>

        <Scrollbars
          autoHide
          style={{
            height: isMobile ? "calc(100vh - 64px)" : "calc(100vh - 112px)"
          }}
        >
          <Menu
            theme={theme}
            onClick={this.handleClick}
            selectedKeys={[selectedKeys]}
            openKeys={openKeys}
            onOpenChange={this.onOpenChange}
            mode="inline"
            className="menuLeft__navigation"
          >
            {menuItems}
          </Menu>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              position: "absolute",
              alignItems: "center",
              bottom: "45px",
              width: "100%"
            }}
          >
            {params.collapsed ? (
              <div className="menuLeft__logoContainer menuLeft__logoContainer--collapsed">
                <img
                  width={40}
                  src={require("../../../../resources/images/hcs-mark.png")}
                  alt="logo"
                />
              </div>
            ) : (
              <div className="menuLeft__logoContainer">
                <img
                  width={100}
                  src={require("../../../../resources/images/hcs-logo2.png")}
                  alt="logo"
                />
              </div>
            )}
          </div>
        </Scrollbars>
      </Sider>
    );
  }
}

export { MenuLeft, menuData };



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Menu/MenuLeft/index.js